export default [
   {
      kode: '6105012007',
      kecamatan: 'Sintang',
      kelurahan: 'Baning Kota',
   },
   {
      kode: '6105011018',
      kecamatan: 'Sintang',
      kelurahan: 'Rawa Mambok',
   },
   {
      kode: '6105011003',
      kecamatan: 'Sintang',
      kelurahan: 'Tanjung Puri',
   },
   {
      kode: '6105022004',
      kecamatan: 'Tempunak',
      kelurahan: 'Suka Jaya',
   },
   {
      kode: '6105052007',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Panggi Agung',
   },
   {
      kode: '6105011002',
      kecamatan: 'Sintang',
      kelurahan: 'Kapuas Kanan Hulu',
   },
   {
      kode: '6105011022',
      kecamatan: 'Sintang',
      kelurahan: 'Mekar Jaya',
   },
   {
      kode: '6105011001',
      kecamatan: 'Sintang',
      kelurahan: 'Ladang',
   },
   {
      kode: '6105011019',
      kecamatan: 'Sintang',
      kelurahan: 'Sengkuang',
   },
   {
      kode: '6105011025',
      kecamatan: 'Sintang',
      kelurahan: 'Ulak Jaya',
   },
   {
      kode: '6105011024',
      kecamatan: 'Sintang',
      kelurahan: 'Menyumbung Tengah',
   },
   {
      kode: '6105011004',
      kecamatan: 'Sintang',
      kelurahan: 'Kapuas Kanan Hilir',
   },
   {
      kode: '6105032030',
      kecamatan: 'Sepauk',
      kelurahan: 'Sepulut',
   },
   {
      kode: '6105202002',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Sungai Ukoi',
   },
   {
      kode: '6105011016',
      kecamatan: 'Sintang',
      kelurahan: 'Akcaya',
   },
   {
      kode: '6105012014',
      kecamatan: 'Sintang',
      kelurahan: 'Anggah Jaya',
   },
   {
      kode: '6105022009',
      kecamatan: 'Tempunak',
      kelurahan: 'Kenyabur Baru',
   },
   {
      kode: '6105032019',
      kecamatan: 'Sepauk',
      kelurahan: 'Tawang Sari',
   },
   {
      kode: '6105212007',
      kecamatan: 'Binjai Hulu',
      kelurahan: 'Dak Jaya',
   },
   {
      kode: '6105062001',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Senaning',
   },
   {
      kode: '6105202025',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Balai Agung',
   },
   {
      kode: '6105012012',
      kecamatan: 'Sintang',
      kelurahan: 'Merti Guna',
   },
   {
      kode: '6105032017',
      kecamatan: 'Sepauk',
      kelurahan: 'Buluh Kuning',
   },
   {
      kode: '6105052001',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Wirayuda',
   },
   {
      kode: '6105011017',
      kecamatan: 'Sintang',
      kelurahan: 'Alai',
   },
   {
      kode: '6105142001',
      kecamatan: 'Serawai',
      kelurahan: 'Nanga Serawai',
   },
   {
      kode: '6105192003',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Kebong',
   },
   {
      kode: '6105012011',
      kecamatan: 'Sintang',
      kelurahan: 'Sungai Ana',
   },
   {
      kode: '6105202005',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Merarai Dua',
   },
   {
      kode: '6105082014',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Sungai Sintang',
   },
   {
      kode: '6105082004',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Mentunai',
   },
   {
      kode: '6105202001',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Ransi Dakan',
   },
   {
      kode: '6105202008',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Nobal',
   },
   {
      kode: '6105032007',
      kecamatan: 'Sepauk',
      kelurahan: 'Temiang Kapuas',
   },
   {
      kode: '6105011006',
      kecamatan: 'Sintang',
      kelurahan: 'Kapuas Kiri Hulu',
   },
   {
      kode: '6105011023',
      kecamatan: 'Sintang',
      kelurahan: 'Batu Lalau',
   },
   {
      kode: '6105042014',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Beluh Mulyo',
   },
   {
      kode: '6105192006',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Bengkuang',
   },
   {
      kode: '6105192008',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Sungai Pukat',
   },
   {
      kode: '6105192011',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Gemba Raya',
   },
   {
      kode: '6105012028',
      kecamatan: 'Sintang',
      kelurahan: 'Jerora Satu',
   },
   {
      kode: '6105032005',
      kecamatan: 'Sepauk',
      kelurahan: 'Lengkenat',
   },
   {
      kode: '6105032034',
      kecamatan: 'Sepauk',
      kelurahan: 'Sinar Harapan',
   },
   {
      kode: '6105212010',
      kecamatan: 'Binjai Hulu',
      kelurahan: 'Sungai Risap Mensiku Bersatu',
   },
   {
      kode: '6105092002',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Nanga Payak',
   },
   {
      kode: '6105011005',
      kecamatan: 'Sintang',
      kelurahan: 'Kapuas Kiri Hilir',
   },
   {
      kode: '6105152002',
      kecamatan: 'Ambalau',
      kelurahan: 'Nanga Ambalau',
   },
   {
      kode: '6105152001',
      kecamatan: 'Ambalau',
      kelurahan: 'Nanga Kemangai',
   },
   {
      kode: '6105202015',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Lebak Ubah',
   },
   {
      kode: '6105202006',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Kajang Baru',
   },
   {
      kode: '6105032002',
      kecamatan: 'Sepauk',
      kelurahan: 'Tanjung Ria',
   },
   {
      kode: '6105022010',
      kecamatan: 'Tempunak',
      kelurahan: 'Benua Baru',
   },
   {
      kode: '6105202012',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Bancoh',
   },
   {
      kode: '6105042007',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Sungai Deras',
   },
   {
      kode: '6105082016',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Paoh Desa',
   },
   {
      kode: '6105092017',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Nangkak Lestari',
   },
   {
      kode: '6105032006',
      kecamatan: 'Sepauk',
      kelurahan: 'Manis Raya',
   },
   {
      kode: '6105032013',
      kecamatan: 'Sepauk',
      kelurahan: 'Nanga Libau',
   },
   {
      kode: '6105212004',
      kecamatan: 'Binjai Hulu',
      kelurahan: 'Binjai Hilir',
   },
   {
      kode: '6105072018',
      kecamatan: 'Dedai',
      kelurahan: 'Merempit Baru',
   },
   {
      kode: '6105032001',
      kecamatan: 'Sepauk',
      kelurahan: 'Nanga Sepauk',
   },
   {
      kode: '6105072015',
      kecamatan: 'Dedai',
      kelurahan: 'Lundang Baru',
   },
   {
      kode: '6105042002',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Setungkup',
   },
   {
      kode: '6105052025',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Padung Kumang',
   },
   {
      kode: '6105082009',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Nanga Tikan',
   },
   {
      kode: '6105032022',
      kecamatan: 'Sepauk',
      kelurahan: 'Bedayan',
   },
   {
      kode: '6105072012',
      kecamatan: 'Dedai',
      kelurahan: 'Mangat Baru',
   },
   {
      kode: '6105052009',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Argo Mulyo',
   },
   {
      kode: '6105202018',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Rarai',
   },
   {
      kode: '6105082007',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Nyangkom',
   },
   {
      kode: '6105022008',
      kecamatan: 'Tempunak',
      kelurahan: 'Pagal Baru',
   },
   {
      kode: '6105202004',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Merarai Satu',
   },
   {
      kode: '6105212005',
      kecamatan: 'Binjai Hulu',
      kelurahan: 'Binjai Hulu',
   },
   {
      kode: '6105212006',
      kecamatan: 'Binjai Hulu',
      kelurahan: 'Sungai Risap',
   },
   {
      kode: '6105142006',
      kecamatan: 'Serawai',
      kelurahan: 'Tontang',
   },
   {
      kode: '6105202026',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Kunyai',
   },
   {
      kode: '6105032003',
      kecamatan: 'Sepauk',
      kelurahan: 'Sekubang',
   },
   {
      kode: '6105072019',
      kecamatan: 'Dedai',
      kelurahan: 'Dedai Kanan',
   },
   {
      kode: '6105062003',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Sebadak',
   },
   {
      kode: '6105072006',
      kecamatan: 'Dedai',
      kelurahan: 'Pengkadan Baru',
   },
   {
      kode: '6105202014',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Solam Raya',
   },
   {
      kode: '6105152020',
      kecamatan: 'Ambalau',
      kelurahan: 'Lunjan Tingang',
   },
   {
      kode: '6105032023',
      kecamatan: 'Sepauk',
      kelurahan: 'Tanjung Hulu',
   },
   {
      kode: '6105092001',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Nanga Tebidah',
   },
   {
      kode: '6105082018',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Mekar Mandiri',
   },
   {
      kode: '6105152026',
      kecamatan: 'Ambalau',
      kelurahan: 'Patih Jepara',
   },
   {
      kode: '6105202011',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Bonet Lama',
   },
   {
      kode: '6105202010',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Bonet Engkabang',
   },
   {
      kode: '6105072009',
      kecamatan: 'Dedai',
      kelurahan: 'Baras',
   },
   {
      kode: '6105011020',
      kecamatan: 'Sintang',
      kelurahan: 'Mengkurai',
   },
   {
      kode: '6105142004',
      kecamatan: 'Serawai',
      kelurahan: 'Begori',
   },
   {
      kode: '6105032027',
      kecamatan: 'Sepauk',
      kelurahan: 'Sukau Bersatu',
   },
   {
      kode: '6105062016',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Sekaih',
   },
   {
      kode: '6105042017',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Betung Permai',
   },
   {
      kode: '6105042025',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Maung',
   },
   {
      kode: '6105062004',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Sepiluk',
   },
   {
      kode: '6105062012',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Empunak Tapang Keladan',
   },
   {
      kode: '6105202013',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Perembang',
   },
   {
      kode: '6105032024',
      kecamatan: 'Sepauk',
      kelurahan: 'Sungai Raya',
   },
   {
      kode: '6105202003',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Manter',
   },
   {
      kode: '6105062005',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Sungai Seria',
   },
   {
      kode: '6105032021',
      kecamatan: 'Sepauk',
      kelurahan: 'Paoh Benua',
   },
   {
      kode: '6105032014',
      kecamatan: 'Sepauk',
      kelurahan: 'Bernayau',
   },
   {
      kode: '6105032016',
      kecamatan: 'Sepauk',
      kelurahan: 'Nanga Pari',
   },
   {
      kode: '6105032015',
      kecamatan: 'Sepauk',
      kelurahan: 'Sinar Pekayau',
   },
   {
      kode: '6105042018',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Kenuak',
   },
   {
      kode: '6105032020',
      kecamatan: 'Sepauk',
      kelurahan: 'Gernis Jaya',
   },
   {
      kode: '6105022006',
      kecamatan: 'Tempunak',
      kelurahan: 'Peribang Baru',
   },
   {
      kode: '6105022015',
      kecamatan: 'Tempunak',
      kelurahan: 'Gurung Mali',
   },
   {
      kode: '6105052021',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Panggi Ruguk',
   },
   {
      kode: '6105092006',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Entogong',
   },
   {
      kode: '6105032011',
      kecamatan: 'Sepauk',
      kelurahan: 'Semuntai',
   },
   {
      kode: '6105022005',
      kecamatan: 'Tempunak',
      kelurahan: 'Mengkurat Baru',
   },
   {
      kode: '6105022001',
      kecamatan: 'Tempunak',
      kelurahan: 'Nanga Tempunak',
   },
   {
      kode: '6105082001',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Nanga Mau',
   },
   {
      kode: '6105042008',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Nanga Sejirak',
   },
   {
      kode: '6105212009',
      kecamatan: 'Binjai Hulu',
      kelurahan: 'Empaka Kabiau Raya',
   },
   {
      kode: '6105202007',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Gurung Kempadik',
   },
   {
      kode: '6105022018',
      kecamatan: 'Tempunak',
      kelurahan: 'Balai Harapan',
   },
   {
      kode: '6105011021',
      kecamatan: 'Sintang',
      kelurahan: 'Kedabang',
   },
   {
      kode: '6105032036',
      kecamatan: 'Sepauk',
      kelurahan: 'Nanga Layung',
   },
   {
      kode: '6105032010',
      kecamatan: 'Sepauk',
      kelurahan: 'Sekujam Timbai',
   },
   {
      kode: '6105212011',
      kecamatan: 'Binjai Hulu',
      kelurahan: 'Simba Raya',
   },
   {
      kode: '6105192012',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Karya Jaya Bhakti',
   },
   {
      kode: '6105022019',
      kecamatan: 'Tempunak',
      kelurahan: 'Tempunak Kapuas',
   },
   {
      kode: '6105042001',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Nanga Ketungau',
   },
   {
      kode: '6105072016',
      kecamatan: 'Dedai',
      kelurahan: 'Penyak Lalang',
   },
   {
      kode: '6105192009',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Sungai Maram',
   },
   {
      kode: '6105082002',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Jambu',
   },
   {
      kode: '6105082017',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Jaya Sakti',
   },
   {
      kode: '6105062007',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Nanga Bayan',
   },
   {
      kode: '6105192007',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Pelimping',
   },
   {
      kode: '6105062013',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Sebetung Paluk',
   },
   {
      kode: '6105142016',
      kecamatan: 'Serawai',
      kelurahan: 'Sawang Senghiang',
   },
   {
      kode: '6105032009',
      kecamatan: 'Sepauk',
      kelurahan: 'Mait Hilir',
   },
   {
      kode: '6105082015',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Sungai Garong',
   },
   {
      kode: '6105212008',
      kecamatan: 'Binjai Hulu',
      kelurahan: 'Mensiku',
   },
   {
      kode: '6105032033',
      kecamatan: 'Sepauk',
      kelurahan: 'Tanjung Balai',
   },
   {
      kode: '6105202016',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Melayang Sari',
   },
   {
      kode: '6105082011',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Kerapa Sepan',
   },
   {
      kode: '6105052016',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Senangan Kecil',
   },
   {
      kode: '6105042010',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Senibung',
   },
   {
      kode: '6105092026',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Landau Bara',
   },
   {
      kode: '6105032012',
      kecamatan: 'Sepauk',
      kelurahan: 'Sirang Setambang',
   },
   {
      kode: '6105022022',
      kecamatan: 'Tempunak',
      kelurahan: 'Kupan Jaya',
   },
   {
      kode: '6105032029',
      kecamatan: 'Sepauk',
      kelurahan: 'Peninsung',
   },
   {
      kode: '6105072002',
      kecamatan: 'Dedai',
      kelurahan: 'Nanga Dedai',
   },
   {
      kode: '6105062027',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Ujung Kempas',
   },
   {
      kode: '6105052012',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Margahayu',
   },
   {
      kode: '6105012026',
      kecamatan: 'Sintang',
      kelurahan: 'Tebing Raya',
   },
   {
      kode: '6105072004',
      kecamatan: 'Dedai',
      kelurahan: 'Sungai Mali',
   },
   {
      kode: '6105142027',
      kecamatan: 'Serawai',
      kelurahan: 'Muara Kota',
   },
   {
      kode: '6105192001',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Nanga Lebang',
   },
   {
      kode: '6105192017',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Kelam Sejahtera',
   },
   {
      kode: '6105212003',
      kecamatan: 'Binjai Hulu',
      kelurahan: 'Telaga Dua',
   },
   {
      kode: '6105142005',
      kecamatan: 'Serawai',
      kelurahan: 'Pagar Lebata',
   },
   {
      kode: '6105192002',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Merpak',
   },
   {
      kode: '6105022014',
      kecamatan: 'Tempunak',
      kelurahan: 'Kuala Tiga',
   },
   {
      kode: '6105052004',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Tirta Karya',
   },
   {
      kode: '6105052028',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Kubu Berangan',
   },
   {
      kode: '6105032028',
      kecamatan: 'Sepauk',
      kelurahan: 'Kemantan',
   },
   {
      kode: '6105032018',
      kecamatan: 'Sepauk',
      kelurahan: 'Temawang Muntai',
   },
   {
      kode: '6105072007',
      kecamatan: 'Dedai',
      kelurahan: 'Taok',
   },
   {
      kode: '6105072014',
      kecamatan: 'Dedai',
      kelurahan: 'Emparu Baru',
   },
   {
      kode: '6105072001',
      kecamatan: 'Dedai',
      kelurahan: 'Nanga Jetak',
   },
   {
      kode: '6105152021',
      kecamatan: 'Ambalau',
      kelurahan: 'Bukit Tinggi',
   },
   {
      kode: '6105202017',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Sarai',
   },
   {
      kode: '6105202020',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Penjernang Hulu',
   },
   {
      kode: '6105082012',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Sungai Buaya',
   },
   {
      kode: '6105142026',
      kecamatan: 'Serawai',
      kelurahan: 'Batu Ketebung',
   },
   {
      kode: '6105042020',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Batu Nyadi',
   },
   {
      kode: '6105072023',
      kecamatan: 'Dedai',
      kelurahan: 'Apin Baru',
   },
   {
      kode: '6105072024',
      kecamatan: 'Dedai',
      kelurahan: 'Jangkang',
   },
   {
      kode: '6105202021',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Riam Kijang',
   },
   {
      kode: '6105062002',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Empura',
   },
   {
      kode: '6105052006',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Sumber Sari',
   },
   {
      kode: '6105042004',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Sungai Mali',
   },
   {
      kode: '6105202009',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Baya Betung',
   },
   {
      kode: '6105062017',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Bekuan Luyang',
   },
   {
      kode: '6105142030',
      kecamatan: 'Serawai',
      kelurahan: 'Nusa Tujuh',
   },
   {
      kode: '6105202022',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Baya Mulya',
   },
   {
      kode: '6105142028',
      kecamatan: 'Serawai',
      kelurahan: 'Mekar Sari',
   },
   {
      kode: '6105022020',
      kecamatan: 'Tempunak',
      kelurahan: 'Riam Batu',
   },
   {
      kode: '6105142013',
      kecamatan: 'Serawai',
      kelurahan: 'Tanjung Raya',
   },
   {
      kode: '6105042012',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Baung Sengatap',
   },
   {
      kode: '6105062018',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Sungai Pisau',
   },
   {
      kode: '6105052010',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Wana Bhakti',
   },
   {
      kode: '6105072017',
      kecamatan: 'Dedai',
      kelurahan: 'Umin Jaya',
   },
   {
      kode: '6105202023',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Laman Raya',
   },
   {
      kode: '6105092012',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Nanga Abai',
   },
   {
      kode: '6105062011',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Nanga Bugau',
   },
   {
      kode: '6105072008',
      kecamatan: 'Dedai',
      kelurahan: 'Empaci',
   },
   {
      kode: '6105022011',
      kecamatan: 'Tempunak',
      kelurahan: 'Tinum Baru',
   },
   {
      kode: '6105072030',
      kecamatan: 'Dedai',
      kelurahan: 'Samak',
   },
   {
      kode: '6105142034',
      kecamatan: 'Serawai',
      kelurahan: 'Tamakung',
   },
   {
      kode: '6105042021',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Ratu Damai',
   },
   {
      kode: '6105022002',
      kecamatan: 'Tempunak',
      kelurahan: 'Mensiap Baru',
   },
   {
      kode: '6105022023',
      kecamatan: 'Tempunak',
      kelurahan: 'Sungai Buluh',
   },
   {
      kode: '6105212002',
      kecamatan: 'Binjai Hulu',
      kelurahan: 'Telaga Satu',
   },
   {
      kode: '6105052014',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Landau Buaya',
   },
   {
      kode: '6105012008',
      kecamatan: 'Sintang',
      kelurahan: 'Tertung',
   },
   {
      kode: '6105082031',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Mengkirai',
   },
   {
      kode: '6105012013',
      kecamatan: 'Sintang',
      kelurahan: 'Tanjung Kelansam',
   },
   {
      kode: '6105032038',
      kecamatan: 'Sepauk',
      kelurahan: 'Tanjung Mawang',
   },
   {
      kode: '6105062025',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Idai',
   },
   {
      kode: '6105152009',
      kecamatan: 'Ambalau',
      kelurahan: 'Buntut Sabon',
   },
   {
      kode: '6105152029',
      kecamatan: 'Ambalau',
      kelurahan: 'Kolangan Juoi',
   },
   {
      kode: '6105142011',
      kecamatan: 'Serawai',
      kelurahan: 'Baras Nabun',
   },
   {
      kode: '6105152028',
      kecamatan: 'Ambalau',
      kelurahan: 'Luting Mingan',
   },
   {
      kode: '6105022016',
      kecamatan: 'Tempunak',
      kelurahan: 'Merti Jaya',
   },
   {
      kode: '6105152004',
      kecamatan: 'Ambalau',
      kelurahan: 'Nanga Menakon',
   },
   {
      kode: '6105142008',
      kecamatan: 'Serawai',
      kelurahan: 'Nanga Riyoi',
   },
   {
      kode: '6105062006',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Suak Medang',
   },
   {
      kode: '6105152023',
      kecamatan: 'Ambalau',
      kelurahan: 'Nusa Koring',
   },
   {
      kode: '6105152030',
      kecamatan: 'Ambalau',
      kelurahan: 'Nanga Rade',
   },
   {
      kode: '6105152010',
      kecamatan: 'Ambalau',
      kelurahan: 'Nanga Keremoi',
   },
   {
      kode: '6105062019',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Mungguk Entawak',
   },
   {
      kode: '6105062009',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Jasa',
   },
   {
      kode: '6105152024',
      kecamatan: 'Ambalau',
      kelurahan: 'Purut Beribit',
   },
   {
      kode: '6105152022',
      kecamatan: 'Ambalau',
      kelurahan: 'Bukai Tukun',
   },
   {
      kode: '6105152007',
      kecamatan: 'Ambalau',
      kelurahan: 'Kepala Jungai',
   },
   {
      kode: '6105142014',
      kecamatan: 'Serawai',
      kelurahan: 'Tahai Permai',
   },
   {
      kode: '6105152031',
      kecamatan: 'Ambalau',
      kelurahan: 'Jengkarang',
   },
   {
      kode: '6105142021',
      kecamatan: 'Serawai',
      kelurahan: 'Rantau Malam',
   },
   {
      kode: '6105142018',
      kecamatan: 'Serawai',
      kelurahan: 'Teluk Harapan',
   },
   {
      kode: '6105152005',
      kecamatan: 'Ambalau',
      kelurahan: 'Nanga Sake',
   },
   {
      kode: '6105152027',
      kecamatan: 'Ambalau',
      kelurahan: 'Korong Daso',
   },
   {
      kode: '6105142012',
      kecamatan: 'Serawai',
      kelurahan: 'Nanga Jelundung',
   },
   {
      kode: '6105152006',
      kecamatan: 'Ambalau',
      kelurahan: 'Buntut Pimpin',
   },
   {
      kode: '6105152012',
      kecamatan: 'Ambalau',
      kelurahan: 'Buntut Purun',
   },
   {
      kode: '6105152013',
      kecamatan: 'Ambalau',
      kelurahan: 'Nanga Sakai',
   },
   {
      kode: '6105062008',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Rasau',
   },
   {
      kode: '6105062024',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Sungai Kelik',
   },
   {
      kode: '6105062015',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Nanga Sebawang',
   },
   {
      kode: '6105152011',
      kecamatan: 'Ambalau',
      kelurahan: 'Nanga Menantak',
   },
   {
      kode: '6105192005',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Ensaid Panjang',
   },
   {
      kode: '6105042009',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Semuntai',
   },
   {
      kode: '6105142036',
      kecamatan: 'Serawai',
      kelurahan: 'Mensulung Bio',
   },
   {
      kode: '6105022003',
      kecamatan: 'Tempunak',
      kelurahan: 'Tanjung Perada',
   },
   {
      kode: '6105082005',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Tuguk',
   },
   {
      kode: '6105022026',
      kecamatan: 'Tempunak',
      kelurahan: 'Mensiap Jaya',
   },
   {
      kode: '6105062010',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Sungai Bugau',
   },
   {
      kode: '6105072003',
      kecamatan: 'Dedai',
      kelurahan: 'Gandis',
   },
   {
      kode: '6105142007',
      kecamatan: 'Serawai',
      kelurahan: 'Karya Jaya',
   },
   {
      kode: '6105142022',
      kecamatan: 'Serawai',
      kelurahan: 'Mentajoi',
   },
   {
      kode: '6105142037',
      kecamatan: 'Serawai',
      kelurahan: 'Sabhang Landan',
   },
   {
      kode: '6105142015',
      kecamatan: 'Serawai',
      kelurahan: 'Merako Jaya',
   },
   {
      kode: '6105142038',
      kecamatan: 'Serawai',
      kelurahan: 'Nanga Tangoi',
   },
   {
      kode: '6105142023',
      kecamatan: 'Serawai',
      kelurahan: 'Nanga Bihe',
   },
   {
      kode: '6105042013',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Semajau Mekar',
   },
   {
      kode: '6105072021',
      kecamatan: 'Dedai',
      kelurahan: 'Gandis Hulu',
   },
   {
      kode: '6105192015',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Sungai Labi',
   },
   {
      kode: '6105192013',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Mandiri Jaya',
   },
   {
      kode: '6105062020',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Embaleh',
   },
   {
      kode: '6105052017',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Sungai Areh',
   },
   {
      kode: '6105032037',
      kecamatan: 'Sepauk',
      kelurahan: 'Limau Bakti',
   },
   {
      kode: '6105142002',
      kecamatan: 'Serawai',
      kelurahan: 'Nanga Mentatai',
   },
   {
      kode: '6105082043',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Monbai Begununk',
   },
   {
      kode: '6105082020',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Karya Baru',
   },
   {
      kode: '6105092003',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Tanjung Bunga',
   },
   {
      kode: '6105072026',
      kecamatan: 'Dedai',
      kelurahan: 'Mengkirai Jaya',
   },
   {
      kode: '6105022025',
      kecamatan: 'Tempunak',
      kelurahan: 'Pekulai Bersatu',
   },
   {
      kode: '6105042019',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Jentawang Hilir',
   },
   {
      kode: '6105022012',
      kecamatan: 'Tempunak',
      kelurahan: 'Pangkal Baru',
   },
   {
      kode: '6105082024',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Linggam Permai',
   },
   {
      kode: '6105032026',
      kecamatan: 'Sepauk',
      kelurahan: 'Bangun',
   },
   {
      kode: '6105082040',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Sungai Pengga',
   },
   {
      kode: '6105082010',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Pelaik',
   },
   {
      kode: '6105022021',
      kecamatan: 'Tempunak',
      kelurahan: 'Pudau Bersatu',
   },
   {
      kode: '6105042005',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Air Nyuruk',
   },
   {
      kode: '6105192010',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Sepan Lebang',
   },
   {
      kode: '6105192004',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Baning Panjang',
   },
   {
      kode: '6105092024',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Merahau Permai',
   },
   {
      kode: '6105012029',
      kecamatan: 'Sintang',
      kelurahan: 'Kebiau Baru',
   },
   {
      kode: '6105062021',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Sebuluh',
   },
   {
      kode: '6105072005',
      kecamatan: 'Dedai',
      kelurahan: 'Riguk',
   },
   {
      kode: '6105092009',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Lintang Tambuk',
   },
   {
      kode: '6105092015',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Nanga Oran',
   },
   {
      kode: '6105062023',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Engkeruh',
   },
   {
      kode: '6105042011',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Tanjung Baung',
   },
   {
      kode: '6105092004',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Nanga Toran',
   },
   {
      kode: '6105202024',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Sabang Surai',
   },
   {
      kode: '6105032004',
      kecamatan: 'Sepauk',
      kelurahan: 'Kenyauk',
   },
   {
      kode: '6105082023',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Lalang Inggar',
   },
   {
      kode: '6105010000',
      kecamatan: 'Sintang',
      kelurahan: '-',
   },
   {
      kode: '6105022007',
      kecamatan: 'Tempunak',
      kelurahan: 'Repak Sari',
   },
   {
      kode: '6105050000',
      kecamatan: 'Ketungau Tengah',
      kelurahan: '-',
   },
   {
      kode: '6105042022',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Lepung Pantak',
   },
   {
      kode: '6105052011',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Swadaya',
   },
   {
      kode: '6105082013',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Pakak',
   },
   {
      kode: '6105032040',
      kecamatan: 'Sepauk',
      kelurahan: 'Sungai Jaung',
   },
   {
      kode: '6105150000',
      kecamatan: 'Ambalau',
      kelurahan: '-',
   },
   {
      kode: '6105200000',
      kecamatan: 'Sungai Tebelian',
      kelurahan: '-',
   },
   {
      kode: '6105022024',
      kecamatan: 'Tempunak',
      kelurahan: 'Jaya Mentari',
   },
   {
      kode: '6105030000',
      kecamatan: 'Sepauk',
      kelurahan: '-',
   },
   {
      kode: '6105190000',
      kecamatan: 'Kelam Permai',
      kelurahan: '-',
   },
   {
      kode: '6105092019',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Mapan Jaya',
   },
   {
      kode: '6105070000',
      kecamatan: 'Dedai',
      kelurahan: '-',
   },
   {
      kode: '6105052003',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Panding Jaya',
   },
   {
      kode: '6105032035',
      kecamatan: 'Sepauk',
      kelurahan: 'Riam Kempadik',
   },
   {
      kode: '6105142017',
      kecamatan: 'Serawai',
      kelurahan: 'Tunas Harapan',
   },
   {
      kode: '6105072013',
      kecamatan: 'Dedai',
      kelurahan: 'Manaong Baru',
   },
   {
      kode: '6105022017',
      kecamatan: 'Tempunak',
      kelurahan: 'Benua Kencana',
   },
   {
      kode: '6105060000',
      kecamatan: 'Ketungau Hulu',
      kelurahan: '-',
   },
   {
      kode: '6105040000',
      kecamatan: 'Ketungau Hilir',
      kelurahan: '-',
   },
   {
      kode: '6105092021',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Buluh Merindu',
   },
   {
      kode: '6105052029',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Semareh',
   },
   {
      kode: '6105152032',
      kecamatan: 'Ambalau',
      kelurahan: 'Deme',
   },
   {
      kode: '6105052018',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Mungguk Gelombang',
   },
   {
      kode: '6105192016',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Sungai Lais',
   },
   {
      kode: '6105012009',
      kecamatan: 'Sintang',
      kelurahan: 'Mungguk Bantok',
   },
   {
      kode: '6105082025',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Sungai Menuang',
   },
   {
      kode: '6105042023',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Pampang Dua',
   },
   {
      kode: '6105192014',
      kecamatan: 'Kelam Permai',
      kelurahan: 'Landau Kodam',
   },
   {
      kode: '6105012010',
      kecamatan: 'Sintang',
      kelurahan: 'Teluk Kelansam',
   },
   {
      kode: '6105082022',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Engkerangan',
   },
   {
      kode: '6105052027',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Senangan Jaya',
   },
   {
      kode: '6105052005',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Begelang Jaya',
   },
   {
      kode: '6105210000',
      kecamatan: 'Binjai Hulu',
      kelurahan: '-',
   },
   {
      kode: '6105140000',
      kecamatan: 'Serawai',
      kelurahan: '-',
   },
   {
      kode: '6105072020',
      kecamatan: 'Dedai',
      kelurahan: 'Sungai Tapang',
   },
   {
      kode: '6105202019',
      kecamatan: 'Sungai Tebelian',
      kelurahan: 'Penjernang',
   },
   {
      kode: '6105082006',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Natai Tebedak',
   },
   {
      kode: '6105212001',
      kecamatan: 'Binjai Hulu',
      kelurahan: 'Ampar Bedang',
   },
   {
      kode: '6105072025',
      kecamatan: 'Dedai',
      kelurahan: 'Belinyuk Sibau',
   },
   {
      kode: '6105072027',
      kecamatan: 'Dedai',
      kelurahan: 'Terusan',
   },
   {
      kode: '6105052022',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Bakti Senabung',
   },
   {
      kode: '6105052015',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Kayu Dujung',
   },
   {
      kode: '6105062022',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Riam Sejawak',
   },
   {
      kode: '6105152008',
      kecamatan: 'Ambalau',
      kelurahan: 'Tanjung Andan',
   },
   {
      kode: '6105052026',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Radin Jaya',
   },
   {
      kode: '6105082033',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Buluk Jegara',
   },
   {
      kode: '6105072031',
      kecamatan: 'Dedai',
      kelurahan: 'Manyam',
   },
   {
      kode: '6105082032',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Tanjung Keliling',
   },
   {
      kode: '6105092014',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Riam Muntik',
   },
   {
      kode: '6105032025',
      kecamatan: 'Sepauk',
      kelurahan: 'Landau Panjang',
   },
   {
      kode: '6105092025',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Tanah Merah',
   },
   {
      kode: '6105072022',
      kecamatan: 'Dedai',
      kelurahan: 'Hulu Dedai',
   },
   {
      kode: '6105082035',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Tanjung Putar',
   },
   {
      kode: '6105072010',
      kecamatan: 'Dedai',
      kelurahan: 'Pangkadan Sungai Rupa',
   },
   {
      kode: '6105082038',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Kempas Raya',
   },
   {
      kode: '6105032008',
      kecamatan: 'Sepauk',
      kelurahan: 'Ensabang',
   },
   {
      kode: '6105072011',
      kecamatan: 'Dedai',
      kelurahan: 'Kumpang',
   },
   {
      kode: '6105092029',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Tapang Manua',
   },
   {
      kode: '6105012015',
      kecamatan: 'Sintang',
      kelurahan: 'Lalang Baru',
   },
   {
      kode: '6105022013',
      kecamatan: 'Tempunak',
      kelurahan: 'Pulau Jaya',
   },
   {
      kode: '6105042015',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Batu Ampar',
   },
   {
      kode: '6105032031',
      kecamatan: 'Sepauk',
      kelurahan: 'Temawang Bulai',
   },
   {
      kode: '6105092023',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Emponyang',
   },
   {
      kode: '6105072028',
      kecamatan: 'Dedai',
      kelurahan: 'Tanjung',
   },
   {
      kode: '6105012027',
      kecamatan: 'Sintang',
      kelurahan: 'Mail Jampong',
   },
   {
      kode: '6105092011',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Nanga Ungai',
   },
   {
      kode: '6105032032',
      kecamatan: 'Sepauk',
      kelurahan: 'Sungai Segak',
   },
   {
      kode: '6105082008',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Melingkat',
   },
   {
      kode: '6105042024',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Mungguk Kelapa',
   },
   {
      kode: '6105052023',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Engkitan',
   },
   {
      kode: '6105082037',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Sungai Meraya',
   },
   {
      kode: '6105062014',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Muakan Petinggi',
   },
   {
      kode: '6105152003',
      kecamatan: 'Ambalau',
      kelurahan: 'Nanga Kesange',
   },
   {
      kode: '6105042006',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Nanga Merkak',
   },
   {
      kode: '6105142019',
      kecamatan: 'Serawai',
      kelurahan: 'Gurung Senghiang',
   },
   {
      kode: '6105052002',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Tanjung Sari',
   },
   {
      kode: '6105052020',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Nanga Kelapan',
   },
   {
      kode: '6105092031',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Kebarau',
   },
   {
      kode: '6105142035',
      kecamatan: 'Serawai',
      kelurahan: 'Limbur Bernaung Lestari',
   },
   {
      kode: '6105142003',
      kecamatan: 'Serawai',
      kelurahan: 'Bedaha',
   },
   {
      kode: '6105062028',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Neraci Jaya',
   },
   {
      kode: '6105092013',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Nanga Laar',
   },
   {
      kode: '6105152016',
      kecamatan: 'Ambalau',
      kelurahan: 'Riam Sabon',
   },
   {
      kode: '6105052019',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Mungguk Lawang',
   },
   {
      kode: '6105092030',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Nanga Tampang',
   },
   {
      kode: '6105052008',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Kerta Sari',
   },
   {
      kode: '6105142024',
      kecamatan: 'Serawai',
      kelurahan: 'Nanga Tekungai',
   },
   {
      kode: '6105142025',
      kecamatan: 'Serawai',
      kelurahan: 'Talian Sahabung',
   },
   {
      kode: '6105092028',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Merah Arai',
   },
   {
      kode: '6105152019',
      kecamatan: 'Ambalau',
      kelurahan: 'Dahtah Bungai',
   },
   {
      kode: '6105092005',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Riam Panjang',
   },
   {
      kode: '6105052013',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Gut Jaya Bhakti',
   },
   {
      kode: '6105092007',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Nanga Tonggoi',
   },
   {
      kode: '6105092010',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Nanga Masau',
   },
   {
      kode: '6105092020',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Tanjung Miru',
   },
   {
      kode: '6105042016',
      kecamatan: 'Ketungau Hilir',
      kelurahan: 'Bukit Sidin Permai',
   },
   {
      kode: '6105052024',
      kecamatan: 'Ketungau Tengah',
      kelurahan: 'Landau Temiang',
   },
   {
      kode: '6105142031',
      kecamatan: 'Serawai',
      kelurahan: 'Nanga Ruhan',
   },
   {
      kode: '6105152033',
      kecamatan: 'Ambalau',
      kelurahan: 'Nanga Pahangan',
   },
   {
      kode: '6105062026',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Sungai Mawang',
   },
   {
      kode: '6105152018',
      kecamatan: 'Ambalau',
      kelurahan: 'Mensuang',
   },
   {
      kode: '6105092022',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Empakan',
   },
   {
      kode: '6105092027',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Kerapuk Jaya',
   },
   {
      kode: '6105082042',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Neran Baya',
   },
   {
      kode: '6105152017',
      kecamatan: 'Ambalau',
      kelurahan: 'Nanga Ukai',
   },
   {
      kode: '6105082026',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Natai Lesung',
   },
   {
      kode: '6105142020',
      kecamatan: 'Serawai',
      kelurahan: 'Tanjung Harapan',
   },
   {
      kode: '6105142010',
      kecamatan: 'Serawai',
      kelurahan: 'Nanga Segulang',
   },
   {
      kode: '6105072029',
      kecamatan: 'Dedai',
      kelurahan: 'Batu Landung',
   },
   {
      kode: '6105082021',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Bukit Segaloh',
   },
   {
      kode: '6105152025',
      kecamatan: 'Ambalau',
      kelurahan: 'Pulou Sabhang',
   },
   {
      kode: '6105092008',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Tanjung Lalau',
   },
   {
      kode: '6105142032',
      kecamatan: 'Serawai',
      kelurahan: 'Meroboi',
   },
   {
      kode: '6105082030',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Nanga Lidau',
   },
   {
      kode: '6105082027',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Begendang Mal',
   },
   {
      kode: '6105082029',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Lengkong Bindu',
   },
   {
      kode: '6105152015',
      kecamatan: 'Ambalau',
      kelurahan: 'Sungai Tambun',
   },
   {
      kode: '6105062029',
      kecamatan: 'Ketungau Hulu',
      kelurahan: 'Sejawak',
   },
   {
      kode: '6105082003',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Tertung Mau',
   },
   {
      kode: '6105082019',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Landau Beringin',
   },
   {
      kode: '6105082028',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Sungai Ranap',
   },
   {
      kode: '6105082034',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Buluk Panjang',
   },
   {
      kode: '6105082036',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Sungai Emang',
   },
   {
      kode: '6105082039',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Ipoh Emang',
   },
   {
      kode: '6105082041',
      kecamatan: 'Kayan Hilir',
      kelurahan: 'Batu Netak',
   },
   {
      kode: '6105142009',
      kecamatan: 'Serawai',
      kelurahan: 'Buntut Ponte',
   },
   {
      kode: '6105142029',
      kecamatan: 'Serawai',
      kelurahan: 'Tanjung Baru',
   },
   {
      kode: '6105142033',
      kecamatan: 'Serawai',
      kelurahan: 'Panekasan',
   },
   {
      kode: '6105092016',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Tonak Goneh',
   },
   {
      kode: '6105092018',
      kecamatan: 'Kayan Hulu',
      kelurahan: 'Topan Nanga',
   },
   {
      kode: '6105152014',
      kecamatan: 'Ambalau',
      kelurahan: 'Nanga Mentomoi',
   },
   {
      kode: '6105032039',
      kecamatan: 'Sepauk',
      kelurahan: 'Bungkong Baru',
   },
]
